import pixzzi from '../../../img/pixzzi.png';
import './Projectrightimage.css';

const ProjectImage = () => {
  return (
    <img 
      src={pixzzi} 
      alt="Pixzzi image search and download platform" 
      className="photossss reveal fade-right" 
    />
  );
};

export default ProjectImage;
